import { useQuery, UseQueryResult } from '@tanstack/react-query';
import Request from '@hotmart-org-ca/request';

interface BiometricSessionData {
  ucode: string;
  [key: string]: unknown;
}

const useBiometricSessionCheck = (
  active: number,
  hasError: boolean
): UseQueryResult<BiometricSessionData, Error> =>
  useQuery<BiometricSessionData>({
    queryKey: ['biometric.session.check', active],
    queryFn: () => Request('biometric.session.check'),
    enabled: !hasError,
  });

export default useBiometricSessionCheck;
